(function ($, UX) {
    let abLogger = {
        loggingUrl: '/action/clientSideLogging',

        selectors: {
            trigger: '.js__abTestingTrigger',
            doiLink: 'a[href^="/doi/"]',
            childElement: '.search__item, .creative-work, .item',
        },

        init() {
            let $parent = $(this.selectors.trigger);
            if ($parent.length > 0) {
                let expType = $parent.data('exp-type');
                let queryId = $parent.data('query-id');
                let itemSelector = $parent.data('child-selector')
                    ? $parent.data('child-selector')
                    : this.selectors.childElement;
                this.logSearchResultsByHrefSelector(expType, queryId, $parent.find(itemSelector));
            }
        },

        logClick(e, doi, expType, queryId, pos) {
            $.ajax({
                url: this.loggingUrl,
                data: {
                    type: '102',
                    doi: doi,
                    queryId: queryId,
                    exp: expType,
                    event: 'click',
                    pos: pos + 1,
                },
                async: false,
            });
            e.stopImmediatePropagation();
            return true;
        },

        logSearchResultsByHrefSelector(expType, queryId, $elm) {
            let $links = $elm.find(this.selectors.doiLink);
            let that = this;
            $links.each(function (i) {
                let doi = that.sliceDoiFromHref($(this).attr('href'));
                that.bindElementToMouseUpEvent(this, doi, expType, queryId, i);
            });
        },

        bindElementToMouseUpEvent(element, doi, expType, queryId, i) {
            let that = this;
            $(element).on('mouseup', function (e) {
                switch (e.which) {
                    case 1:
                        // Left click;
                        that.logClick(e, doi, expType, queryId, i);
                        break;
                    case 2:
                        // Wheel click (new tab);
                        that.logClick(e, doi, expType, queryId, i);
                        break;
                    case 3:
                        // Right click;
                        // No proper way to track 'Open in new window / tab' from context menu at the moment.
                        break;
                }
                return true;
            });
        },

        sliceDoiFromHref(href) {
            let doi = href.split('/');
            let doiFirst = doi[doi.length - 2];
            let doiLast = doi[doi.length - 1];
            if (doiLast.indexOf('?') > 0) {
                doiLast = doiLast.substring(0, doiLast.indexOf('?'));
            }
            return doiFirst + '/' + doiLast;
        },
    };

    UX.abLogger = abLogger;
})(jQuery, UX);
